import React, { useState } from 'react';
import { Sparkles, Scissors, Check, Clock, ArrowRight, ShieldCheck, Heart, Award, Star, ChevronRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { services } from '../data/services';

export default function HairpieceBillboard({ onSelectService, onOpenBooking, onOpenGenderBooking, onNavigate }) {
  const { lang } = useLanguage();

  // Active sub-service selection for each of the 3 panels
  const [activeProtezId, setActiveProtezId] = useState('hp-full-package');
  const [activeMenId, setActiveMenId] = useState('m-haircut');
  const [activeWomenId, setActiveWomenId] = useState('w-wash-cut-dry');

  const handleBookService = (serviceId) => {
    const srv = services.find(s => s.id === serviceId);
    if (onSelectService && srv) {
      onSelectService(srv);
    } else if (onOpenBooking) {
      onOpenBooking();
    }
  };

  const handleOpenCatalog = (gender, catId) => {
    if (onOpenGenderBooking) {
      onOpenGenderBooking(gender, catId);
    } else if (onOpenBooking) {
      onOpenBooking();
    }
  };

  const tickerItems = [
    lang === 'nl' ? "👑 100% ECHT NATUURLIJK MENSENHAAR" : lang === 'tr' ? "👑 %100 DOĞAL GERÇEK İNSAN SAÇI" : "👑 100% REAL HUMAN HAIR",
    lang === 'nl' ? "✂️ HEREN & DAMES KAPPER ROTTERDAM" : lang === 'tr' ? "✂️ ERKEK & BAYAN KUAFÖRÜ ROTTERDAM" : "✂️ MEN & WOMEN HAIR SALON",
    lang === 'nl' ? "💧 ZWEMMEN, SPORTEN & DOUCHEN MOGELIJK" : lang === 'tr' ? "💧 HAVUZ, SPOR VE DUŞA %100 DAYANIKLI" : "💧 100% WATER & SWEAT PROOF",
    lang === 'nl' ? "🎯 ONZICHTBARE NATUURLIJKE HAARLIJN" : lang === 'tr' ? "🎯 FARK EDİLMEYEN DOĞAL ÖN SAÇ ÇİZGİSİ" : "🎯 INVISIBLE NATURAL HAIRLINE",
    lang === 'nl' ? "✨ HEREN & DAMES KNIPPEN, FÖHNEN & STYLING" : lang === 'tr' ? "✨ SAÇ KESİMİ, SAKAL, FÖN & PERMA" : "✨ HAIRCUT, BEARD, BLOW-DRY & PERM",
    lang === 'nl' ? "⭐ 5.0 GOOGLE WAARDERING ROTTERDAM" : lang === 'tr' ? "⭐ 5.0 GOOGLE PUANI ROTTERDAM" : "⭐ 5.0 GOOGLE RATED ROTTERDAM",
    lang === 'nl' ? "🛡️ MEDISCH VERLIJMD & HUIDVRIENDELIJK" : lang === 'tr' ? "🛡️ MEDİKAL SABİTLEME & CİLT DOSTU" : "🛡️ MEDICAL GRADE BONDING"
  ];

  // =========================================================================
  // 1. PANEL: PROTEZ SAÇ (HAARWERK) - Tik atılan kutu (Ölçüm & Bakım içerde)
  // =========================================================================
  const protezOptions = [
    {
      id: "hp-full-package",
      chip: lang === 'nl' ? "👑 Compleet Pakket" : lang === 'tr' ? "👑 Tam Paket" : "👑 Full Package",
      title: lang === 'nl' ? "Compleet Haarwerk Pakket" : lang === 'tr' ? "Tam Protez Saç Paketi" : "Full Hairpiece Package",
      price: "€500",
      duration: "120 min",
      highlights: lang === 'nl' ? [
        "100% echt haar & op maat gemaakte mal",
        "Medische verlijming + skin fade knippen"
      ] : lang === 'tr' ? [
        "%100 gerçek insan saçı & özel kalıp",
        "Medikal sabitleme + sıfır geçişli kesim"
      ] : [
        "100% real human hair & custom template",
        "Medical bonding + skin fade cut"
      ],
      btnText: lang === 'nl' ? "Paket Seç (€500)" : lang === 'tr' ? "Paketi Seç (€500)" : "Select Package (€500)"
    },
    {
      id: "hp-consultation",
      chip: lang === 'nl' ? "✨ Gratis Intake" : lang === 'tr' ? "✨ Ön Görüşme (Ücretsiz)" : "✨ Free Intake",
      title: lang === 'nl' ? "Adviesgesprek & Opmeten" : lang === 'tr' ? "Ölçüm & Ön Görüşme" : "Free Consultation",
      price: lang === 'nl' ? "GRATIS" : lang === 'tr' ? "ÜCRETSİZ" : "FREE",
      duration: "30 min",
      highlights: lang === 'nl' ? [
        "Özel VIP kabinde birebir ölçüm",
        "Renk & yoğunluk tespiti • Bağlayıcılık yok"
      ] : lang === 'tr' ? [
        "Özel VIP kabinde birebir ölçüm",
        "Renk & yoğunluk tespiti • Bağlayıcılık yok"
      ] : [
        "Private VIP booth & template fit",
        "Color & density match • Zero obligation"
      ],
      btnText: lang === 'nl' ? "Gratis Afspraak Maken" : lang === 'tr' ? "Ücretsiz Randevu Al" : "Book Free Intake"
    },
    {
      id: "hp-monthly-maintenance",
      chip: lang === 'nl' ? "🛡️ Onderhoud (€60)" : lang === 'tr' ? "🛡️ Aylık Bakım (€60)" : "🛡️ Maintenance (€60)",
      title: lang === 'nl' ? "Onderhoud & Styling" : lang === 'tr' ? "Aylık Bakım & Kesim" : "Monthly Maintenance",
      price: "€60",
      duration: "60 min",
      highlights: lang === 'nl' ? [
        "Dieptereiniging & verse medische tape",
        "Eigen haar strak knippen & föhnen"
      ] : lang === 'tr' ? [
        "Derin temizlik & yeni medikal bant",
        "Kendi saçınızın kesimi (fade) & fön"
      ] : [
        "Deep cleanse & fresh medical tapes",
        "Own hair fade cut & styling"
      ],
      btnText: lang === 'nl' ? "Bakım Seç (€60)" : lang === 'tr' ? "Bakım Randevusu Al (€60)" : "Book Maintenance (€60)"
    }
  ];

  // =========================================================================
  // 2. PANEL: ERKEK SAÇ KESİMİ (HEREN KNIPPEN) - "Erkek kesimi için randevu al"
  // =========================================================================
  const menOptions = [
    {
      id: "m-haircut",
      chip: lang === 'nl' ? "✂️ Knippen (€25)" : lang === 'tr' ? "✂️ Saç Kesimi (€25)" : "✂️ Haircut (€25)",
      title: lang === 'nl' ? "Heren Knippen" : lang === 'tr' ? "Erkek Saç Kesimi" : "Men's Haircut",
      price: "€25",
      duration: "30 min",
      highlights: lang === 'nl' ? [
        "Klassieke of moderne knipbeurt op maat",
        "Professionele styling met pomade of wax"
      ] : lang === 'tr' ? [
        "Klasik veya modern makas & makine kesimi",
        "Özel wax & pomad ile usta şekillendirme"
      ] : [
        "Custom classic or modern precision haircut",
        "Styling with premium pomade or matte wax"
      ],
      btnText: lang === 'nl' ? "Afspraak Heren Knippen (€25)" : lang === 'tr' ? "Erkek Kesimi İçin Randevu Al" : "Book Men's Haircut"
    },
    {
      id: "m-hair-beard-combo",
      chip: lang === 'nl' ? "💈 Haar & Baard (€35)" : lang === 'tr' ? "💈 Saç & Sakal (€35)" : "💈 Hair & Beard (€35)",
      title: lang === 'nl' ? "Haar & Baard Knippen" : lang === 'tr' ? "Saç ve Sakal Kesimi" : "Haircut & Beard Trim",
      price: "€35",
      duration: "45 min",
      highlights: lang === 'nl' ? [
        "Complete herensnit + strakke baardlijnen",
        "Warme handdoek & verzorgende baardolie"
      ] : lang === 'tr' ? [
        "Komple saç kesimi + ustura ile sakal hatları",
        "Sıcak havlu kompresi & besleyici sakal yağı"
      ] : [
        "Full haircut + straight-razor beard sculpt",
        "Hot towel compress & beard nourishment"
      ],
      btnText: lang === 'nl' ? "Afspraak Haar & Baard (€35)" : lang === 'tr' ? "Saç & Sakal Randevusu Al (€35)" : "Book Hair & Beard (€35)"
    },
    {
      id: "m-wash-haircut",
      chip: lang === 'nl' ? "🧴 Wassen & Knippen (€27)" : lang === 'tr' ? "🧴 Yıkama & Kesim (€27)" : "🧴 Wash & Cut (€27)",
      title: lang === 'nl' ? "Wassen en Heren Knippen" : lang === 'tr' ? "Yıkama ve Saç Kesimi" : "Wash & Haircut",
      price: "€27",
      duration: "35 min",
      highlights: lang === 'nl' ? [
        "Verfrissende wasbeurt & hoofdhuidmassage",
        "Nauwkeurige herensnit afgestemd op u"
      ] : lang === 'tr' ? [
        "Ferahlatıcı şampuanla yıkama & kafa masajı",
        "Kafa yapısına uygun özenli saç kesimi"
      ] : [
        "Refreshing wash & revitalizing massage",
        "Precision cut tailored to your facial lines"
      ],
      btnText: lang === 'nl' ? "Afspraak Wassen & Knippen (€27)" : lang === 'tr' ? "Yıkama & Kesim Randevusu Al (€27)" : "Book Wash & Cut (€27)"
    },
    {
      id: "m-beard-shave-only",
      chip: lang === 'nl' ? "🪒 Baard Scheren (€17,50)" : lang === 'tr' ? "🪒 Sakal Tıraşı (€17,50)" : "🪒 Beard Trim (€17.50)",
      title: lang === 'nl' ? "Alleen Baard Scheren" : lang === 'tr' ? "Yalnızca Sakal Tıraşı" : "Beard Shave Only",
      price: "€17,50",
      duration: "20 min",
      highlights: lang === 'nl' ? [
        "Scheren of trimmen van de baard contouren",
        "Warme handdoek compress & razor lijnen"
      ] : lang === 'tr' ? [
        "Sakal şekillendirme ve sıcak havlu kompresi",
        "Sinekkaydı veya ustura ile keskin hat tıraşı"
      ] : [
        "Beard contouring with straight razor lines",
        "Hot towel treatment & soothing balm"
      ],
      btnText: lang === 'nl' ? "Afspraak Baard Scheren (€17,50)" : lang === 'tr' ? "Sakal Tıraşı Randevusu Al (€17,50)" : "Book Beard Shave (€17.50)"
    },
    {
      id: "m-boys-under-6",
      chip: lang === 'nl' ? "🧒 Jongens tot 6j (€20)" : lang === 'tr' ? "🧒 Erkek Çocuk (€20)" : "🧒 Boys under 6 (€20)",
      title: lang === 'nl' ? "Jongens Knippen (tot 6 jaar)" : lang === 'tr' ? "6 Yaşına Kadar Erkek Çocuk Kesimi" : "Boys Haircut (under 6)",
      price: "€20",
      duration: "25 min",
      highlights: lang === 'nl' ? [
        "Geduldige & vriendelijke kindersnit",
        "Snelle, stoere en stijlvolle afwerking"
      ] : lang === 'tr' ? [
        "Minik beylere özel neşeli ve hızlı kesim",
        "Sabırlı, güler yüzlü ve modern tarz saç kesimi"
      ] : [
        "Gentle, fun haircut for young boys",
        "Fast, friendly and modern cool styling"
      ],
      btnText: lang === 'nl' ? "Afspraak Jongens Knippen (€20)" : lang === 'tr' ? "Çocuk Kesimi Randevusu Al (€20)" : "Book Boys Haircut (€20)"
    },
    {
      id: "m-perm",
      chip: lang === 'nl' ? "🌀 Heren Permanent (€110)" : lang === 'tr' ? "🌀 Erkek Perma (€110)" : "🌀 Men's Perm (€110)",
      title: lang === 'nl' ? "Heren Permanent" : lang === 'tr' ? "Erkek Perma" : "Men's Perm",
      price: "€110",
      duration: "60 min",
      highlights: lang === 'nl' ? [
        "Natuurlijke krullen, textuur en volume",
        "Moderne bukle terapisi ile trend dalgalar"
      ] : lang === 'tr' ? [
        "Erkekler için modern dalga ve doğal bukle",
        "Saça ekstra hacim ve dolgunluk kazandırma"
      ] : [
        "Natural defined curls and modern texture",
        "Long-lasting bouncy volume for men"
      ],
      btnText: lang === 'nl' ? "Afspraak Heren Permanent (€110)" : lang === 'tr' ? "Erkek Perma Randevusu Al (€110)" : "Book Men's Perm (€110)"
    }
  ];

  // =========================================================================
  // 3. PANEL: BAYAN SAÇ KESİMİ (DAMES KNIPPEN) - "Bayan saç kesimi için randevu al"
  // =========================================================================
  const womenOptions = [
    {
      id: "w-wash-cut-dry",
      chip: lang === 'nl' ? "✂️ Wassen & Knippen (€35)" : lang === 'tr' ? "✂️ Saç Kesimi (€35)" : "✂️ Wash, Cut & Dry (€35)",
      title: lang === 'nl' ? "Wassen, Knippen en Drogen" : lang === 'tr' ? "Yıkama, Kesim ve Kurutma" : "Wash, Haircut & Dry",
      price: "€35",
      duration: "45 min",
      highlights: lang === 'nl' ? [
        "Professioneel wassen & verzorgende conditioner",
        "Vakkundige knipbeurt op maat en natuurlijk drogen"
      ] : lang === 'tr' ? [
        "Profesyonel saç yıkama ve nem bakımı",
        "Yüz hatlarınıza özel özenli kesim ve kurutma"
      ] : [
        "Professional wash & nourishing conditioning",
        "Tailored haircut to suit your facial structure"
      ],
      btnText: lang === 'nl' ? "Afspraak Dames Knippen (€35)" : lang === 'tr' ? "Bayan Saç Kesimi İçin Randevu Al" : "Book Women's Haircut"
    },
    {
      id: "w-curly-wash-cut",
      chip: lang === 'nl' ? "🌀 Krullend Haar (€40)" : lang === 'tr' ? "🌀 Kıvırcık Kesim (€40)" : "🌀 Curly Cut (€40)",
      title: lang === 'nl' ? "Krullend Haar Wassen & Knippen" : lang === 'tr' ? "Kıvırcık Saç Yıkama & Kesim" : "Curly Hair Wash & Cut",
      price: "€40",
      duration: "50 min",
      highlights: lang === 'nl' ? [
        "Speciale kniptechniek voor krullend en golvend haar",
        "Veerkracht en definitie maximaliseren"
      ] : lang === 'tr' ? [
        "Kıvırcık ve dalgalı saçlara özel bukle belirginleştirici",
        "Hacim kazandırıcı ve elektriklenmeyi önleyen kesim"
      ] : [
        "Specialized cut for natural curls & texture",
        "Bounce & definition curl enhancement"
      ],
      btnText: lang === 'nl' ? "Afspraak Krullen Knippen (€40)" : lang === 'tr' ? "Kıvırcık Kesim Randevusu Al (€40)" : "Book Curly Cut (€40)"
    },
    {
      id: "w-bangs-cut",
      chip: lang === 'nl' ? "💇‍♀️ Pony Knippen (€10)" : lang === 'tr' ? "💇‍♀️ Kâkül Kesimi (€10)" : "💇‍♀️ Bangs Trim (€10)",
      title: lang === 'nl' ? "Pony Knippen" : lang === 'tr' ? "Kâkül / Pony Kesimi" : "Bangs / Fringe Trim",
      price: "€10",
      duration: "15 min",
      highlights: lang === 'nl' ? [
        "Snelle en nauwkeurige pony knipbeurt",
        "Frisse oogopslag en gezichtscontouren"
      ] : lang === 'tr' ? [
        "Hızlı ve hassas kâkül düzeltme",
        "Yüz çerçeveleme ve pratik şekillendirme"
      ] : [
        "Quick precision bangs trim for eyes framing",
        "Face accentuating sharp styling"
      ],
      btnText: lang === 'nl' ? "Afspraak Pony Knippen (€10)" : lang === 'tr' ? "Kâkül Randevusu Al (€10)" : "Book Bangs Trim (€10)"
    },
    {
      id: "w-girls-under-6",
      chip: lang === 'nl' ? "👧 Meisjes tot 6j (€25)" : lang === 'tr' ? "👧 Kız Çocuk (€25)" : "👧 Girls under 6 (€25)",
      title: lang === 'nl' ? "Meisjes Knippen (tot 6 jaar)" : lang === 'tr' ? "6 Yaşına Kadar Kız Çocuk Kesimi" : "Girls Haircut (under 6)",
      price: "€25",
      duration: "30 min",
      highlights: lang === 'nl' ? [
        "Geduldige, vriendelijke en comfortabele knipbeurt",
        "Voor kleine meisjes inclusief lichte styling"
      ] : lang === 'tr' ? [
        "Küçük prenseslere özel sabırlı ve neşeli kesim",
        "Kırıkları alma ve hafif fön kurutma"
      ] : [
        "Patient, gentle haircut for young girls",
        "Split-ends cleanup and light gentle blow-dry"
      ],
      btnText: lang === 'nl' ? "Afspraak Meisjes Knippen (€25)" : lang === 'tr' ? "Kız Çocuk Randevusu Al (€25)" : "Book Girls Haircut (€25)"
    },
    {
      id: "style-blowdry",
      chip: lang === 'nl' ? "💁 Föhnen (€25*)" : lang === 'tr' ? "💁 Fön & Şekil (€25*)" : "💁 Blow-dry (€25*)",
      title: lang === 'nl' ? "Föhnen & Styling" : lang === 'tr' ? "Fön & Şekillendirme" : "Blow-dry & Styling",
      price: "€25*",
      duration: "30 min",
      highlights: lang === 'nl' ? [
        "Professioneel in model geföhnd met prachtig volume",
        "Zijdezacht resultaat en spiegelglans (Vanaf prijs)"
      ] : lang === 'tr' ? [
        "Düz, kırık veya dalgalı hacimli fön çekimi",
        "Isı koruyucu serum ve kalıcı parlaklık"
      ] : [
        "Salon-finish blow-dry with luxurious bounce",
        "Heat defense serum & glossy shine (From price)"
      ],
      btnText: lang === 'nl' ? "Afspraak Föhnen (€25)" : lang === 'tr' ? "Fön Randevusu Al (€25)" : "Book Blow-dry (€25)"
    },
    {
      id: "w-perm",
      chip: lang === 'nl' ? "🌀 Permanent (€110*)" : lang === 'tr' ? "🌀 Bayan Perma (€110*)" : "🌀 Women's Perm (€110*)",
      title: lang === 'nl' ? "Permanent Behandeling" : lang === 'tr' ? "Bayan Perma İşlemi" : "Women's Perm Treatment",
      price: "€110*",
      duration: "90 min",
      highlights: lang === 'nl' ? [
        "Veerkrachtige krullen & langdurig volume",
        "Natuurlijke slag ve kalıcı dolgunluk (Vanaf prijs)"
      ] : lang === 'tr' ? [
        "Saça hacim, dolgunluk ve doğal bukleler",
        "Aylarca kalıcı profesyonel perma uygulaması"
      ] : [
        "Bouncy curls & long-lasting natural waves",
        "Salon-grade volume perm therapy"
      ],
      btnText: lang === 'nl' ? "Afspraak Permanent Dames (€110)" : lang === 'tr' ? "Bayan Perma Randevusu Al (€110)" : "Book Women's Perm (€110)"
    }
  ];

  // Active objects
  const curProtez = protezOptions.find(o => o.id === activeProtezId) || protezOptions[0];
  const curMen = menOptions.find(o => o.id === activeMenId) || menOptions[0];
  const curWomen = womenOptions.find(o => o.id === activeWomenId) || womenOptions[0];

  return (
    <section className="w-full bg-slate-950 text-white pt-2 pb-6 sm:pb-8 border-b border-amber-500/30 relative overflow-hidden select-none">
      
      {/* 📢 1. İNCE VE AKICI KESİNTİSİZ KAYAN ŞERİT (SLIM TICKER) */}
      <div className="w-full bg-gradient-to-r from-amber-500 via-yellow-400 to-amber-500 text-slate-950 py-1.5 overflow-hidden font-black text-[11px] uppercase tracking-wider shadow-sm mb-4">
        <div className="flex items-center whitespace-nowrap animate-marquee">
          {tickerItems.concat(tickerItems).map((item, idx) => (
            <span key={idx} className="shrink-0 flex items-center gap-3 px-4 font-black text-slate-950">
              <span>{item}</span>
              <span className="text-slate-900/40 text-[9px]">✦</span>
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* 🏷️ 2. KOMPAKT BAŞLIK ÇİZGİSİ */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 mb-4 pb-2 border-b border-slate-800/80">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
            <h2 className="text-sm sm:text-base font-black tracking-tight text-white uppercase flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-amber-400" />
              <span>{lang === 'nl' ? 'Aura Hair Rotterdam • Populaire Diensten & Snel Boeken' : lang === 'tr' ? 'Aura Hair Rotterdam • Popüler Hizmetler & Hızlı Randevu' : 'Aura Hair Rotterdam • Popular Services & Quick Booking'}</span>
            </h2>
          </div>
          <span className="text-[11px] font-medium text-amber-300/80">
            {lang === 'nl' ? 'Protez Saç • Heren Kapsalon • Dames Kapsalon • Samuel Esmeijerplein 3' : lang === 'tr' ? 'Protez Saç • Erkek Kuaförü • Bayan Kuaförü • Samuel Esmeijerplein 3' : 'Hair Systems • Men\'s Salon • Women\'s Salon • Samuel Esmeijerplein 3'}
          </span>
        </div>

        {/* 🎴 3. ÜÇ KARE (3 KOMPAKT PANEL) */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3.5 sm:gap-4 items-stretch">
          
          {/* ========================================================= */}
          {/* 👑 KUTU 1: PROTEZ SAÇ (HAARWERK) - TİK ATILAN KUTU */}
          {/* ========================================================= */}
          <div className="relative rounded-2xl overflow-hidden border border-amber-400/50 hover:border-amber-400 ring-1 ring-amber-400/20 bg-slate-900/90 shadow-lg flex flex-col justify-between transition-all duration-300 hover:scale-[1.01] hover:shadow-xl group">
            <div>
              {/* 🖼️ Fotoğraf */}
              <div className="relative h-36 sm:h-40 overflow-hidden bg-slate-950">
                <picture>
                  <source media="(max-width: 640px)" srcSet="/images/hair_system_result_3_1788255394814_mob.webp" type="image/webp" />
                  <img
                    src="/images/hair_system_result_3_1788255394814.webp"
                    alt={curProtez.title}
                    width="400"
                    height="160"
                    className="w-full h-full object-cover object-top filter brightness-[0.95] contrast-[1.05] group-hover:scale-105 transition-transform duration-500 ease-out"
                    loading="eager"
                    fetchPriority="high"
                  />
                </picture>
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent" />

                {/* Rozet */}
                <div className="absolute top-2 left-2 z-10">
                  <span className="px-2 py-0.5 rounded text-[10px] uppercase tracking-wider shadow bg-amber-400 text-slate-950 font-black flex items-center gap-1">
                    <span>👑</span>
                    <span>{lang === 'nl' ? 'MEEST GEKOZEN' : lang === 'tr' ? 'EN ÇOK TERCİH EDİLEN' : 'TOP CHOICE'}</span>
                  </span>
                </div>

                {/* Fiyat Etiketi (Dinamik) */}
                <div className="absolute bottom-2 right-2 z-10">
                  <div className="px-2.5 py-1 rounded-lg shadow-md font-black text-sm sm:text-base flex items-center gap-1 bg-gradient-to-r from-amber-400 to-amber-500 text-slate-950">
                    <span>{curProtez.price}</span>
                  </div>
                </div>
              </div>

              {/* 📝 İçerik */}
              <div className="p-3 sm:p-3.5 space-y-2.5">
                <div className="flex items-center justify-between">
                  <h3 className="text-xs sm:text-sm font-black text-white uppercase tracking-tight group-hover:text-amber-400 transition-colors truncate">
                    {curProtez.title}
                  </h3>
                  <span className="text-[10px] font-bold text-amber-400 flex items-center gap-0.5 shrink-0 ml-2">
                    <Clock className="w-2.5 h-2.5" />
                    <span>{curProtez.duration}</span>
                  </span>
                </div>

                {/* 🎛️ DİĞER SEÇENEKLER İÇERDE: Ölçüm ve Aylık Bakım hap butonları */}
                <div className="pt-1 border-t border-slate-800">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400 block mb-1.5 flex items-center justify-between">
                    <span>{lang === 'nl' ? 'Kies Behandeling:' : lang === 'tr' ? 'Hizmet Seçimi:' : 'Select Option:'}</span>
                    <span className="text-[9px] text-amber-400 font-semibold">{protezOptions.length} {lang === 'nl' ? 'opties' : lang === 'tr' ? 'seçenek' : 'options'}</span>
                  </span>
                  <div className="grid grid-cols-3 gap-1">
                    {protezOptions.map((opt) => {
                      const isActive = activeProtezId === opt.id;
                      return (
                        <button
                          key={opt.id}
                          type="button"
                          onClick={() => setActiveProtezId(opt.id)}
                          className={`py-1.5 px-1 rounded-lg text-[10px] font-bold transition-all text-center truncate cursor-pointer border ${
                            isActive
                              ? 'bg-amber-400 text-slate-950 border-amber-300 shadow-sm font-black scale-[1.02]'
                              : 'bg-slate-950/70 text-slate-300 hover:text-white hover:bg-slate-800 border-slate-800'
                          }`}
                          title={opt.title}
                        >
                          {opt.chip}
                        </button>
                      );
                    })}
                  </div>
                </div>

                {/* Vurucu Maddeler */}
                <div className="space-y-1 pt-1.5 border-t border-slate-800/80">
                  {curProtez.highlights.map((h, hIdx) => (
                    <div key={hIdx} className="flex items-center gap-1.5 text-[11px] text-slate-300">
                      <Check className="w-3 h-3 text-amber-400 shrink-0 stroke-[3]" />
                      <span className="truncate">{h}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* 🎯 Kompakt Buton & Alt Link */}
            <div className="p-3 sm:p-3.5 pt-0 space-y-2">
              <button
                type="button"
                onClick={() => handleBookService(curProtez.id)}
                className="w-full py-2.5 px-3 rounded-lg text-xs uppercase tracking-wider flex items-center justify-center gap-1.5 shadow transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] cursor-pointer bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-slate-950 font-black shadow-amber-500/25"
              >
                <Scissors className="w-3.5 h-3.5 stroke-[2.5]" />
                <span className="truncate">{curProtez.btnText}</span>
                <ArrowRight className="w-3.5 h-3.5 stroke-[2.5]" />
              </button>

              <button
                type="button"
                onClick={() => handleOpenCatalog('men', 'mens_hairpiece')}
                className="w-full text-center text-[11px] font-bold text-amber-300/80 hover:text-amber-200 transition-colors flex items-center justify-center gap-1 cursor-pointer py-0.5"
              >
                <span>{lang === 'nl' ? '✦ Alle Haarwerk Pakketten Bekijken' : lang === 'tr' ? '✦ Tüm Protez Saç Seçenekleri (3 Paket)' : '✦ View All Hair Systems'}</span>
                <ChevronRight className="w-3 h-3" />
              </button>
            </div>
          </div>

          {/* ========================================================= */}
          {/* 💈 KUTU 2: ERKEK SAÇ KESİMİ - "Erkek kesimi için randevu al" */}
          {/* ========================================================= */}
          <div className="relative rounded-2xl overflow-hidden border border-cyan-400/50 hover:border-cyan-400 ring-1 ring-cyan-400/20 bg-slate-900/90 shadow-lg flex flex-col justify-between transition-all duration-300 hover:scale-[1.01] hover:shadow-xl group">
            <div>
              {/* 🖼️ Fotoğraf */}
              <div className="relative h-36 sm:h-40 overflow-hidden bg-slate-950">
                <picture>
                  <source media="(max-width: 640px)" srcSet="/images/hair_system_result_1_1788255360381_mob.webp" type="image/webp" />
                  <img
                    src="/images/hair_system_result_1_1788255360381.webp"
                    alt={curMen.title}
                    width="400"
                    height="160"
                    className="w-full h-full object-cover object-top filter brightness-[0.95] contrast-[1.05] group-hover:scale-105 transition-transform duration-500 ease-out"
                    loading="lazy"
                  />
                </picture>
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent" />

                {/* Rozet */}
                <div className="absolute top-2 left-2 z-10">
                  <span className="px-2 py-0.5 rounded text-[10px] uppercase tracking-wider shadow bg-cyan-400 text-slate-950 font-black flex items-center gap-1">
                    <span>👨</span>
                    <span>{lang === 'nl' ? 'HEREN / ERKEK' : lang === 'tr' ? 'ERKEK KUAFÖRÜ' : 'MEN\'S SALON'}</span>
                  </span>
                </div>

                {/* Fiyat Etiketi (Dinamik) */}
                <div className="absolute bottom-2 right-2 z-10">
                  <div className="px-2.5 py-1 rounded-lg shadow-md font-black text-sm sm:text-base flex items-center gap-1 bg-gradient-to-r from-cyan-400 to-blue-500 text-slate-950">
                    <span>{curMen.price}</span>
                  </div>
                </div>
              </div>

              {/* 📝 İçerik */}
              <div className="p-3 sm:p-3.5 space-y-2.5">
                <div className="flex items-center justify-between">
                  <h3 className="text-xs sm:text-sm font-black text-white uppercase tracking-tight group-hover:text-cyan-300 transition-colors truncate">
                    {curMen.title}
                  </h3>
                  <span className="text-[10px] font-bold text-cyan-300 flex items-center gap-0.5 shrink-0 ml-2">
                    <Clock className="w-2.5 h-2.5" />
                    <span>{curMen.duration}</span>
                  </span>
                </div>

                {/* 🎛️ DİĞER SEÇENEKLER İÇERDE: Erkek kesim seçenekleri hap butonları */}
                <div className="pt-1 border-t border-slate-800">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400 block mb-1.5 flex items-center justify-between">
                    <span>{lang === 'nl' ? 'Heren Opties:' : lang === 'tr' ? 'Erkek Hizmetleri:' : 'Men Options:'}</span>
                    <span className="text-[9px] text-cyan-300 font-semibold">{menOptions.length} {lang === 'nl' ? 'opties' : lang === 'tr' ? 'seçenek' : 'options'}</span>
                  </span>
                  <div className="grid grid-cols-3 gap-1">
                    {menOptions.map((opt) => {
                      const isActive = activeMenId === opt.id;
                      return (
                        <button
                          key={opt.id}
                          type="button"
                          onClick={() => setActiveMenId(opt.id)}
                          className={`py-1.5 px-1 rounded-lg text-[10px] font-bold transition-all text-center truncate cursor-pointer border ${
                            isActive
                              ? 'bg-cyan-400 text-slate-950 border-cyan-300 shadow-sm font-black scale-[1.02]'
                              : 'bg-slate-950/70 text-slate-300 hover:text-white hover:bg-slate-800 border-slate-800'
                          }`}
                          title={opt.title}
                        >
                          {opt.chip}
                        </button>
                      );
                    })}
                  </div>
                </div>

                {/* Vurucu Maddeler */}
                <div className="space-y-1 pt-1.5 border-t border-slate-800/80">
                  {curMen.highlights.map((h, hIdx) => (
                    <div key={hIdx} className="flex items-center gap-1.5 text-[11px] text-slate-300">
                      <Check className="w-3 h-3 text-cyan-400 shrink-0 stroke-[3]" />
                      <span className="truncate">{h}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* 🎯 Kompakt Buton & Alt Link */}
            <div className="p-3 sm:p-3.5 pt-0 space-y-2">
              <button
                type="button"
                onClick={() => handleBookService(curMen.id)}
                className="w-full py-2.5 px-3 rounded-lg text-xs uppercase tracking-wider flex items-center justify-center gap-1.5 shadow transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] cursor-pointer bg-gradient-to-r from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-slate-950 font-black shadow-cyan-500/25"
              >
                <Scissors className="w-3.5 h-3.5 stroke-[2.5]" />
                <span className="truncate">{curMen.btnText}</span>
                <ArrowRight className="w-3.5 h-3.5 stroke-[2.5]" />
              </button>

              <button
                type="button"
                onClick={() => handleOpenCatalog('men')}
                className="w-full text-center text-[11px] font-bold text-cyan-300/80 hover:text-cyan-200 transition-colors flex items-center justify-center gap-1 cursor-pointer py-0.5"
              >
                <span>{lang === 'nl' ? '✦ Alle Heren Behandelingen Bekijken' : lang === 'tr' ? '✦ Tüm Erkek Hizmetlerini Gör (Randevu Menüsü)' : '✦ View All Men\'s Services'}</span>
                <ChevronRight className="w-3 h-3" />
              </button>
            </div>
          </div>

          {/* ========================================================= */}
          {/* 💇‍♀️ KUTU 3: BAYAN SAÇ KESİMİ - "Bayan saç kesimi için randevu al" */}
          {/* ========================================================= */}
          <div className="relative rounded-2xl overflow-hidden border border-rose-400/50 hover:border-rose-400 ring-1 ring-rose-400/20 bg-slate-900/90 shadow-lg flex flex-col justify-between transition-all duration-300 hover:scale-[1.01] hover:shadow-xl group">
            <div>
              {/* 🖼️ Fotoğraf */}
              <div className="relative h-36 sm:h-40 overflow-hidden bg-slate-950">
                <img
                  src="https://images.unsplash.com/photo-1560869713-7d0a29430803?w=800&auto=format&fit=crop&q=80"
                  alt={curWomen.title}
                  width="400"
                  height="160"
                  className="w-full h-full object-cover object-top filter brightness-[0.95] contrast-[1.05] group-hover:scale-105 transition-transform duration-500 ease-out"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent" />

                {/* Rozet */}
                <div className="absolute top-2 left-2 z-10">
                  <span className="px-2 py-0.5 rounded text-[10px] uppercase tracking-wider shadow bg-gradient-to-r from-rose-500 to-pink-500 text-white font-black flex items-center gap-1">
                    <span>👩</span>
                    <span>{lang === 'nl' ? 'DAMES / KADIN' : lang === 'tr' ? 'BAYAN KUAFÖRÜ' : 'WOMEN\'S SALON'}</span>
                  </span>
                </div>

                {/* Fiyat Etiketi (Dinamik) */}
                <div className="absolute bottom-2 right-2 z-10">
                  <div className="px-2.5 py-1 rounded-lg shadow-md font-black text-sm sm:text-base flex items-center gap-1 bg-gradient-to-r from-rose-400 to-pink-500 text-slate-950">
                    <span>{curWomen.price}</span>
                  </div>
                </div>
              </div>

              {/* 📝 İçerik */}
              <div className="p-3 sm:p-3.5 space-y-2.5">
                <div className="flex items-center justify-between">
                  <h3 className="text-xs sm:text-sm font-black text-white uppercase tracking-tight group-hover:text-rose-300 transition-colors truncate">
                    {curWomen.title}
                  </h3>
                  <span className="text-[10px] font-bold text-rose-300 flex items-center gap-0.5 shrink-0 ml-2">
                    <Clock className="w-2.5 h-2.5" />
                    <span>{curWomen.duration}</span>
                  </span>
                </div>

                {/* 🎛️ DİĞER SEÇENEKLER İÇERDE: Bayan kesim seçenekleri hap butonları */}
                <div className="pt-1 border-t border-slate-800">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400 block mb-1.5 flex items-center justify-between">
                    <span>{lang === 'nl' ? 'Dames Opties:' : lang === 'tr' ? 'Bayan Hizmetleri:' : 'Women Options:'}</span>
                    <span className="text-[9px] text-rose-300 font-semibold">{womenOptions.length} {lang === 'nl' ? 'opties' : lang === 'tr' ? 'seçenek' : 'options'}</span>
                  </span>
                  <div className="grid grid-cols-3 gap-1">
                    {womenOptions.map((opt) => {
                      const isActive = activeWomenId === opt.id;
                      return (
                        <button
                          key={opt.id}
                          type="button"
                          onClick={() => setActiveWomenId(opt.id)}
                          className={`py-1.5 px-1 rounded-lg text-[10px] font-bold transition-all text-center truncate cursor-pointer border ${
                            isActive
                              ? 'bg-rose-400 text-slate-950 border-rose-300 shadow-sm font-black scale-[1.02]'
                              : 'bg-slate-950/70 text-slate-300 hover:text-white hover:bg-slate-800 border-slate-800'
                          }`}
                          title={opt.title}
                        >
                          {opt.chip}
                        </button>
                      );
                    })}
                  </div>
                </div>

                {/* Vurucu Maddeler */}
                <div className="space-y-1 pt-1.5 border-t border-slate-800/80">
                  {curWomen.highlights.map((h, hIdx) => (
                    <div key={hIdx} className="flex items-center gap-1.5 text-[11px] text-slate-300">
                      <Check className="w-3 h-3 text-rose-400 shrink-0 stroke-[3]" />
                      <span className="truncate">{h}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* 🎯 Kompakt Buton & Alt Link */}
            <div className="p-3 sm:p-3.5 pt-0 space-y-2">
              <button
                type="button"
                onClick={() => handleBookService(curWomen.id)}
                className="w-full py-2.5 px-3 rounded-lg text-xs uppercase tracking-wider flex items-center justify-center gap-1.5 shadow transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] cursor-pointer bg-gradient-to-r from-rose-500 via-pink-500 to-rose-500 hover:from-rose-400 hover:to-pink-400 text-white font-black shadow-rose-500/25"
              >
                <Scissors className="w-3.5 h-3.5 stroke-[2.5]" />
                <span className="truncate">{curWomen.btnText}</span>
                <ArrowRight className="w-3.5 h-3.5 stroke-[2.5]" />
              </button>

              <button
                type="button"
                onClick={() => handleOpenCatalog('women')}
                className="w-full text-center text-[11px] font-bold text-rose-300/80 hover:text-rose-200 transition-colors flex items-center justify-center gap-1 cursor-pointer py-0.5"
              >
                <span>{lang === 'nl' ? '✦ Alle Dames Behandelingen Bekijken' : lang === 'tr' ? '✦ Tüm Bayan Hizmetlerini Gör (Randevu Menüsü)' : '✦ View All Women\'s Services'}</span>
                <ChevronRight className="w-3 h-3" />
              </button>
            </div>
          </div>

        </div>

      </div>

    </section>
  );
}
